import { DashboardTileTone } from '../../../DashboardBirdview'
import { OVERVIEW_KPI } from '../RentalPortalOverview.constants'

import DoubleCheckIcon from '../../../../icons/double-check.svg'
import FlatIcon from '../../../../icons/flat.svg'
import ScreeningIcon from '../../../../icons/search.svg'
import UsersIcon from '../../../../icons/users-1.svg'
import ViewingIcon from '../../../../icons/viewing.svg'

export const OVERVIEW_KPI_ROW_COLUMNS = 3

export const QA_NAME_OVERVIEW_KPI_ROW = 'rentalPortalOverviewKpiRow'

export const OVERVIEW_KPI_TILE_LIST = [
  {
    Icon: FlatIcon,
    field: OVERVIEW_KPI.activeListings,
    labelKey: 'RentalPortal.OverviewKpiActiveListingsKey',
    tone: DashboardTileTone.Success,
  },
  {
    Icon: UsersIcon,
    field: OVERVIEW_KPI.newApplicants,
    labelKey: 'RentalPortal.OverviewKpiNewApplicantsKey',
    tone: DashboardTileTone.Warning,
  },
  {
    Icon: ViewingIcon,
    field: OVERVIEW_KPI.viewingsThisWeek,
    labelKey: 'RentalPortal.OverviewKpiViewingsThisWeekKey',
    tone: DashboardTileTone.Info,
  },
  {
    Icon: ScreeningIcon,
    field: OVERVIEW_KPI.applicantsInScreening,
    labelKey: 'RentalPortal.OverviewKpiApplicantsInScreeningKey',
    tone: DashboardTileTone.Purple,
  },
  {
    Icon: DoubleCheckIcon,
    field: OVERVIEW_KPI.listingsClosed,
    labelKey: 'RentalPortal.OverviewKpiListingsClosedKey',
    tone: DashboardTileTone.Success,
  },
]

export const OVERVIEW_KPI_ABBREVIATION_UNIT = 1000

export const OVERVIEW_KPI_ABBREVIATION_SUFFIX = 'k'

export const OVERVIEW_KPI_ABBREVIATION_FORMAT_OPTIONS = {
  maximumFractionDigits: 1,
}
